export default __webpack_public_path__ + "static/media/temp-11.8d3e57b4.svg";